/**
 * Generic frontend debug logging. Only logs when configs['frontendDebug'] === 'true' (env FRONTEND_DEBUG).
 * Off by default. Use for any feature that should hide console logs in production.
 */
export function logIfDebug(configs: { [key: string]: string } | undefined, message: string): void {
    if (configs?.['frontendDebug'] === 'true') {
        console.log(message);
    }
}
